import type {
  PrintTemplate,
  PrintTemplatePreviewInput,
  PrintTemplateType,
} from "@lemmonhq/types";

export type PrintTemplateEditorMode = "create" | "edit";

export type PrintTemplateFormState = PrintTemplatePreviewInput;

export type PrintTemplateListItem = PrintTemplate;

export const DEFAULT_PRINT_TEMPLATE_TYPE: PrintTemplateType = "kitchen_ticket";
